<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header-universal></app-header-universal>
    <div class="appContext">
      <p>권한 보기페이지</p>
    </div>
  </div>
</template>

<script>
import AppHeaderUniversal from '../components/AppHeaderUniversal'
import AppSidebar from '../components/AppSidebar'

export default {
  components: {
    AppHeaderUniversal,
    AppSidebar
  }
}
</script>

<style scoped>

</style>
